import React, { useState, useContext, useEffect } from "react";
import SideBar from "../../../../components/common/SideBar/SideBarNew";
import { LoginContext } from "../../../../helpers/LoginContext";
import { apiGetRequest } from "../../../../helpers/Requests";
import Breadcrumb from "../../../../components/common/Breadcrumb/Breadcrumb";
import {
  EMPLOYEE_BREADCRUMB,
  EMPLOYEE_BREADCRUMB_PAGES,
} from "../../../../Constants/BreadcrumbConstant";
import Header from "../../../../components/common/Header/Header";
import { AiOutlinePlus } from "react-icons/ai";
import { HiOutlineEye } from "react-icons/hi";
import { BsFilterCircle } from "react-icons/bs";
import CircularLoader from "../../../../components/common/CircularLoader/CircularLoader";
import PaginationComponent from "../../../../components/common/Pagination/index";
import { textTruncate, capitalizeFirstLetter, capitalizeWords } from "../../../../Utils/utils";
import {
  USER_ROLE,
} from "../../../../Constants/constant";
import useCareLabels from "hooks/useCareLabels";
import CareLabelSkeleton from "components/common/CareLabelSkeleton/CareLabelSkeleton";
import CareLabelText from "components/common/CareLabelText/CareLabelText";
import { URL_SP_FEEDBACK,URL_WORKER_FEEDBACK_LIST,URL_FEEDBACK_MANAGERS_LIST_FOR_BLACK_PORTAL } from "../../../../store/services/URL";
import { roleAccess } from "../../../../helpers/RolesPermission";
import SelectOption from "components/common/Select/Select";
import AvatarGroup from "../../../../components/common/Avatar/AvatarGroup";
import Search from "../../../../components/common/Search/Search";
import DateRangePickerNew from "../../../../components/common/DateRangePicker/DateRangePickerNew";
import moment from "moment";

import CreateFeedbackModal from "./Modals/CreateFeedbackModal";
import FeedbackDetailModal from "./Modals/FeedbackDetailModal";

const EmployeeFeedback = () => {
  const { participantLabel, participantLabelPlural, isLoading: isCareLabelsLoading } = useCareLabels();
  const { sideBarPadding } = useContext(LoginContext);
  const [isOpen, setisOpen] = useState(false);
  const [detailModalOpen, setDetailModalOpen] = useState(false);
  const [selectedFeedback, setSelectedFeedback] = useState(null);
  const [feedbackList, setFeedbackList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [managerList, setManagerList] = useState([]);
  const [loadingManagers, setLoadingManagers] = useState(false);

  const [statusFilter, setStatusFilter] = useState(null);
  const [participantFilter, setParticipantFilter] = useState(null);
  const [managerFilter, setManagerFilter] = useState(null);
  const [workerFilter, setWorkerFilter] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [showFilters, setShowFilters] = useState(true);

  const [participantsList, setParticipantsList] = useState([]);
  const [loadingParticipants, setLoadingParticipants] = useState(false);

  const [allWorkersList, setAllWorkersList] = useState([]);
  const [filterParticipantsList, setFilterParticipantsList] = useState([]);
  const [selectedParticipantForm, setSelectedParticipantForm] = useState(null);

  const fetchFeedbackList = async (searchTerm = "", currentPage = 1) => {
    setLoading(true);
    try {
      const params = {
        page: currentPage,
        per_page: 10,
        type: "feedback",
      };

      if (searchTerm) {
        params.search = searchTerm;
      }

      if (statusFilter && statusFilter.value) {
        params.status = statusFilter.value;
      }

      if (participantFilter && participantFilter.value) {
        params.participant = participantFilter.label;
      }

      if (managerFilter && managerFilter.value) {
        params.manager = managerFilter.label;
      }

      if (workerFilter && workerFilter.value) {
        params.worker = workerFilter.label;
      }

      if (fromDate) {
        params.date_from = moment(fromDate).format('YYYY-MM-DD');
      }

      if (toDate) {
        params.date_to = moment(toDate).format('YYYY-MM-DD');
      }

      const baseUrl = roleAccess([USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager])
        ? `${URL_SP_FEEDBACK}`
        : `${URL_WORKER_FEEDBACK_LIST}`;

      console.log('Filter params:', params); // Debug log
      const queryString = new URLSearchParams(params).toString();
      const url = `${baseUrl}?${queryString}`;
      console.log('API URL:', url); // Debug log
      const response = await apiGetRequest(url);

      if (response?.status === 200) {
        setFeedbackList(response?.data?.data?.items || []);
        const pagination = response?.data?.data?.pagination;
        if (pagination) {
          setTotalPages(pagination.last_page || 1);
          setTotalCount(pagination.total || 0);
          setPage(pagination.current_page || 1);
        }
      }
    } catch (error) {
      console.error(error);
      setFeedbackList([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchManagersList = async () => {
    setLoadingManagers(true);
    try {
      const response = await apiGetRequest(URL_FEEDBACK_MANAGERS_LIST_FOR_BLACK_PORTAL);
      if (response?.status === 200) {
        const formattedManagers = response?.data?.data?.map((manager) => ({
          id: manager?.user?.id,
          value: manager?.user?.email || manager?.user?.id,
          label: manager?.user?.name || `${manager?.user?.first_name || ''} ${manager?.user?.last_name || ''}`.trim(),
        }));
        setManagerList(formattedManagers || []);
      }
    } catch (error) {
      console.error(error);
      setManagerList([]);
    } finally {
      setLoadingManagers(false);
    }
  };

  const fetchParticipantsList = async () => {
    setLoadingParticipants(true);
    try {
      const response = await apiGetRequest("/hrm/feedback/participants");
      if(response?.status === 200) {
        const formattedParticipants = response?.data?.data?.map((participant) => ({
            value: participant?.uuid || '',
            label: participant?.first_name + " " + participant?.last_name || '',
            id: participant?.id,
        }));
        setParticipantsList(formattedParticipants || []);
      }
    } catch (error) {
      console.error(error);
      setParticipantsList([]);
    } finally {
      setLoadingParticipants(false);
    }
  };

  const fetchWorkersList = async () => {
    try {
      const response = await apiGetRequest("/hrm/feedback/workers");
      if(response?.status === 200) {
        const formattedWorkers = response?.data?.data?.map((worker) => ({
            value: worker?.uuid || worker?.id,
            label: `${worker?.first_name || ''} ${worker?.last_name || ''}`.trim() || worker?.name,
            id: worker?.id,
        }));
        setAllWorkersList(formattedWorkers || []);
      }
    } catch (error) {
      console.error('Error fetching workers:', error);
      // For now, set empty array if endpoint doesn't exist
      setAllWorkersList([]);
    }
  };


  useEffect(() => {
    fetchFeedbackList();
    loadFilterDropdownData();
    fetchManagersList();
  }, []);

  const loadFilterDropdownData = async () => {
    try {
      const response = await apiGetRequest("/hrm/feedback/participants");
      if (response?.status === 200) {
        const formattedParticipants = response?.data?.data?.map((participant) => ({
          value: participant?.uuid || participant?.id,
          label: `${participant?.first_name || ''} ${participant?.last_name || ''}`.trim() || participant?.name,
        }));
        setFilterParticipantsList(formattedParticipants || []);
      }

      await fetchWorkersList();
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      fetchFeedbackList(search, 1);
      setPage(1);
    }, 600);
    return () => clearTimeout(timeOutId);
  }, [search, statusFilter, participantFilter, managerFilter, workerFilter, fromDate, toDate]);

  const openModal = () => {
    setisOpen(true);
    fetchManagersList();
    fetchParticipantsList();
  };

  const closeModal = () => {
    setisOpen(false);
  };

  const openDetailModal = (feedback) => {
    setSelectedFeedback(feedback);
    setDetailModalOpen(true);
  };

  const closeDetailModal = () => {
    setDetailModalOpen(false);
    setSelectedFeedback(null);
  };

  const clearAllFilters = () => {
    setStatusFilter(null);
    setParticipantFilter(null);
    setManagerFilter(null);
    setWorkerFilter(null);
    setFromDate(null);
    setToDate(null);
    setSearch("");
  };

  const getStatusBadgeStyle = (status) => {
    switch(status?.toLowerCase()) {
      case 'pending':
        return 'bg-yellow-50 text-yellow-700 border border-yellow-200';
      case 'in_progress':
        return 'bg-blue-50 text-blue-700 border border-blue-200';
      case 'completed':
      case 'complete':
        return 'bg-green-50 text-green-700 border border-green-200';
      default:
        return 'bg-gray-50 text-gray-700 border border-gray-200';
    }
  };

  const getTypeBadgeStyle = (type) => {
    switch(type?.toLowerCase()) {
      case 'positive':
        return 'bg-green-50 text-green-700 border border-green-200';
      case 'negative':
        return 'bg-red-50 text-red-700 border border-red-200';
      case 'neutral':
        return 'bg-yellow-50 text-yellow-700 border border-yellow-200';
      default:
        return 'bg-gray-50 text-gray-700 border border-gray-200';
    }
  };

  const getTypeDisplay = (type) => {
    if (!type) return 'N/A';
    switch(type.toLowerCase()) {
      case 'positive':
        return 'Positive';
      case 'negative':
        return 'Negative';
      case 'neutral':
        return 'Neutral';
      default:
        return capitalizeFirstLetter(type);
    }
  };


  const getStatusDisplay = (status) => {
    if (!status) return 'Pending';
    switch(status.toLowerCase()) {
      case 'in_progress':
        return 'In Progress';
      case 'completed':
      case 'complete':
        return 'Completed';
      case 'pending':
        return 'Pending';
      default:
        return capitalizeFirstLetter(status);
    }
  };

  return (
    <>
      <div className='min-h-screen w-full'>
        <SideBar />
        <div
          className={`${
            sideBarPadding
              ? "lg:pl-[4rem] duration-300"
              : "lg:pl-64 duration-300"
          } flex flex-col`}
        >
          <main className='flex-1'>
            <Header
              title='Feedback'
              handleClick={openModal}
              btnLabel='Feedback'
              icon={<AiOutlinePlus />}
              isButton
              breadcrumb={
                <Breadcrumb
                  pages={EMPLOYEE_BREADCRUMB(
                    EMPLOYEE_BREADCRUMB_PAGES.FEEDBACK
                  )}
                />
              }
            />

            <div className='w-full px-6'>
              <div className='w-full'>
                <div className='py-4'>
                  {/* <div className='flex items-center justify-between'>
                    <button
                      onClick={() => setShowFilters(!showFilters)}
                      className='flex items-center gap-2 text-gray-700 hover:text-gray-900 font-medium'
                    >
                      <BsFilterCircle className='w-4 h-4' />
                      Filters
                    </button>

                    {(statusFilter || participantFilter || managerFilter || workerFilter || fromDate || toDate || search) && (
                      <button
                        onClick={clearAllFilters}
                        className='text-sm text-blue-600 hover:text-blue-800 font-medium'
                      >
                        Clear All Filters
                      </button>
                    )}
                  </div> */}


                    <div className='mt-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>

   <div>
                       <label className="block text-xs font-medium text-gray-700">Status</label>
                      <SelectOption
                        isClearable={true}
                        newDesign={true}
                        cssClass=''
                        name='status'
                        isSearch={false}
                        data={[
                          { value: 'pending', label: 'Pending' },
                          { value: 'in_progress', label: 'In Progress' },
                          { value: 'completed', label: 'Completed' },
                        ]}
                        selectedOption={statusFilter}
                        handleChange={(e) => {
                          setStatusFilter(e);
                        }}
                        placeHolder='Select Status'
                        maxHeight="350px"
                      />
                      </div>
                         <div>
                       <label className="block text-xs font-medium text-gray-700">
                         {isCareLabelsLoading ? (
                           <CareLabelSkeleton width="w-24" height="h-3.5" />
                         ) : (
                           participantLabel
                         )}
                       </label>

                      <SelectOption
                        isClearable={true}
                        newDesign={true}
                        isDisabled={loadingParticipants}
                        cssClass=''
                        name='participant'
                        isSearch={true}
                        data={filterParticipantsList || []}
                        selectedOption={participantFilter}
                        handleChange={(e) => {
                          setParticipantFilter(e);
                        }}
                        placeHolder={
                          isCareLabelsLoading
                            ? "Select..."
                            : `Select ${participantLabelPlural.slice(0, -1)}`
                        }
                        maxHeight="350px"
                      />
                      </div>
   <div>
                       <label className="block text-xs font-medium text-gray-700">Manager</label>
                      <SelectOption
                        isClearable={true}
                        newDesign={true}
                        isDisabled={loadingManagers}
                        cssClass=''
                        name='manager'
                        isSearch={true}
                        data={managerList || []}
                        selectedOption={managerFilter}
                        handleChange={(e) => {
                          setManagerFilter(e);
                        }}
                        placeHolder='Select Manager'
                        maxHeight="350px"
                      />
                      </div>
   <div>
                       <label className="block text-xs font-medium text-gray-700">Worker</label>
                      <SelectOption
                        isClearable={true}
                        newDesign={true}
                        cssClass=''
                        name='worker'
                        isSearch={true}
                        data={allWorkersList || []}
                        selectedOption={workerFilter}
                        handleChange={(e) => {
                          setWorkerFilter(e);
                        }}
                        placeHolder='Select Worker'
                        maxHeight="350px"
                      />
</div>
   <div>
                       <label className="block text-xs font-medium text-gray-700">Date Range</label>
                      <DateRangePickerNew
                        placeholder={'Date Range'}
                        showCalendarIcon={true}
                        isDisabled={loading}
                        handleCancel={() => {
                          setFromDate(null);
                          setToDate(null);
                        }}
                        handleChange={(obj) => {
                          if (obj && obj.fromDate && obj.toDate) {
                            setFromDate(obj.fromDate);
                            setToDate(obj.toDate);
                          }
                        }}
                        fromDate={fromDate}
                        toDate={toDate}
                      />
                      </div>
                      <div>
                       <label className="block text-xs font-medium text-gray-700">Search</label>
                       <Search
                        search={search}
                        setSearch={setSearch}
                        placeholder='Search feedback...'
                        className='w-full'
                        width={"w-full"}
                      />
                      </div>
                    </div>

                </div>
              </div>
            </div>

            <main className='w-full py-6 px-6'>
              <div className='bg-white shadow-sm rounded-lg overflow-hidden'>
                <div className='overflow-x-auto'>
                  <table className='min-w-full divide-y divide-gray-200 border border-gray-200'>
                    <thead className='bg-blue-50 sticky'>
                      <tr>
                        <th className='py-3.5 text-left text-sm font-semibold text-gray-900 bg-blue-50 px-3' scope="col">
                          ID
                        </th>
                        <th className='py-3.5 text-left text-sm font-semibold text-gray-900 bg-blue-50 px-3' scope="col">
                          Subject
                        </th>
                        <th className='py-3.5 text-left text-sm font-semibold text-gray-900 bg-blue-50 px-3' scope="col">
                          Date
                        </th>
                        <th className='py-3.5 text-left text-sm font-semibold text-gray-900 bg-blue-50 px-3' scope="col">
                          Feedback Type
                        </th>
                        <th className='py-3.5 text-center text-sm font-semibold text-gray-900 bg-blue-50 px-3' scope="col">
                          Status
                        </th>
                        <th className='case py-3.5 text-left text-sm font-semibold text-gray-900 bg-blue-50 px-3' scope="col">
                          {isCareLabelsLoading ? (
                            <CareLabelSkeleton width="w-28" />
                          ) : (
                            participantLabelPlural
                          )}
                        </th>
                         <th className='py-3.5 text-left text-sm font-semibold text-gray-900 bg-blue-50 px-3' scope="col">
                          Manager(s)
                        </th>
                        <th className='py-3.5 text-left text-sm font-semibold text-gray-900 bg-blue-50 px-3' scope="col">
                          Worker(s)
                        </th>
                        <th className='py-3.5 text-left text-sm font-semibold text-gray-900 bg-blue-50 px-3' scope="col">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody className='bg-white divide-y divide-gray-200'>
                      {loading ? (
                        <tr>
                          <td colSpan={8} className='px-6 py-8'>
                            <CircularLoader
                              classes='flex justify-center items-center'
                              classloader='loader-l'
                            />
                          </td>
                        </tr>
                      ) : feedbackList?.length > 0 ? (
                        feedbackList?.map((item, index) => (
                          <tr key={index} className='hover:bg-gray-50'>
                            <td className='px-4 py-4 whitespace-nowrap'>
                              <span className='text-sm font-medium text-blue-600'>
                                  {item?.uuid ? item?.uuid.substring(0, 8).toUpperCase() : 'N/A'}
                              </span>
                            </td>
                            <td className='px-4 py-4'>
                              <span className='text-sm text-gray-900 block max-w-[200px]'>
                                {textTruncate(item?.subject, 20, 20) || 'N/A'}
                              </span>
                            </td>
                            <td className='px-4 py-4 whitespace-nowrap'>
                              <span className='text-sm text-gray-600'>
                                {moment(item?.date).format("DD/MM/YYYY") || 'N/A'}
                              </span>
                            </td>
                            <td className='px-4 py-4 whitespace-nowrap text-center'>
                              {item?.feedback_assessment ? (
                                <span className={`px-2.5 py-1 inline-flex text-xs font-medium rounded-full ${
                                  getTypeBadgeStyle(item?.feedback_assessment)
                                }`}>
                                  {getTypeDisplay(item?.feedback_assessment)}
                                </span>
                              ) : (
                                <span className='text-gray-400 text-sm'>N/A</span>
                              )}
                            </td>
                            <td className='px-4 py-4 whitespace-nowrap text-center'>
                              <span className={`px-2.5 py-1 inline-flex text-xs font-medium rounded-full ${
                                getStatusBadgeStyle(item?.status)
                              }`}>
                                {getStatusDisplay(item?.status)}
                              </span>
                            </td>
                            <td className='px-4 py-4 whitespace-nowrap'>
                              <div className='flex items-center'>
                                {item?.participants && item?.participants.length > 0 ? (
                                  item?.participants.length === 1 ? (
                                    <span className='truncate whitespace-nowrap overflow-ellipsis block text-sm text-gray-600'>
                                      {capitalizeWords(item?.participants[0]?.name) || 'N/A'}
                                    </span>
                                  ) : (
                                    <AvatarGroup
                                      arrayData={item?.participants?.map(participant => ({
                                        ...participant,
                                        first_name: participant?.name?.split(' ')[0] || '',
                                        last_name: participant?.name?.split(' ').slice(1).join(' ') || '',
                                        profile_picture: participant?.profile_picture
                                      }))}
                                      cssClass='mt-0'
                                      maxLength={3}
                                      isNoRing={true}
                                    />
                                  )
                                ) : (
                                  <span className='text-gray-400 text-sm'>
                                    No{" "}
                                    {isCareLabelsLoading ? (
                                      <CareLabelSkeleton width="w-20" height="h-3.5" className="bg-gray-300 align-middle" />
                                    ) : (
                                      participantLabelPlural.toLowerCase()
                                    )}
                                  </span>
                                )}
                              </div>
                            </td>

                            <td className="px-4 py-4 whitespace-nowrap">
                              <div className='flex items-center'>
                                {item?.mention_managers && item?.mention_managers.length > 0 ? (
                                  item?.mention_managers.length === 1 ? (
                                    <span className='truncate whitespace-nowrap overflow-ellipsis block text-sm text-gray-600'>
                                      {capitalizeWords(item?.mention_managers[0]?.name) || 'N/A'}
                                    </span>
                                  ) : (
                                    <AvatarGroup
                                      arrayData={item?.mention_managers?.map(manager => ({
                                        ...manager,
                                        first_name: manager?.name?.split(' ')[0] || '',
                                        last_name: manager?.name?.split(' ').slice(1).join(' ') || '',
                                      }))}
                                      cssClass='mt-0'
                                      maxLength={3}
                                      isNoRing={true}
                                    />
                                  )
                                ) : (
                                  <span className='text-gray-400 text-sm'>No managers</span>
                                )}
                              </div>
                            </td>


                            <td className='px-4 py-4 whitespace-nowrap'>
                              <div className='flex items-center'>
                                {item?.workers && item?.workers.length > 0 ? (
                                  item?.workers.length === 1 ? (
                                    <span className='truncate whitespace-nowrap overflow-ellipsis block text-sm text-gray-600'>
                                      {capitalizeWords(item?.workers[0]?.name) || 'N/A'}
                                    </span>
                                  ) : (
                                    <AvatarGroup
                                      arrayData={item?.workers?.map(worker => ({
                                        ...worker,
                                        first_name: worker?.name?.split(' ')[0] || '',
                                        last_name: worker?.name?.split(' ').slice(1).join(' ') || '',
                                        profile_picture: worker?.photo
                                      }))}
                                      cssClass='mt-0'
                                      maxLength={3}
                                      isNoRing={true}
                                    />
                                  )
                                ) : (
                                  <span className='text-gray-400 text-sm'>No workers</span>
                                )}
                              </div>
                            </td>
                            <td className='flex items-center justify-center whitespace-nowrap '>
                              <button
                                onClick={() => openDetailModal(item)}
                                className='text-gray-600 hover:text-blue-600 hover:bg-blue-50 px-3 py-1.5 rounded-md transition-colors text-sm font-medium'
                              >
                                  <div className='icon-eye-wrapper' title='View'>
                                             <HiOutlineEye className='icon-size' />
                                           </div>
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={8} className='px-6 py-12 text-center'>
                            <div className='flex flex-col items-center'>
                              <div className='text-gray-400 mb-2'>
                                <svg className='w-12 h-12' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                                  <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z' />
                                </svg>
                              </div>
                              <p className='text-gray-500 text-sm'>No feedback found</p>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {(feedbackList.length > 0 && totalPages > 1) && (
                <div className='mt-6'>
                  <PaginationComponent
                    page={page}
                    activeListLength={feedbackList}
                    limit={10}
                    totalList={totalCount}
                    handlePagination={(newPage) => {
                      setPage(newPage);
                      fetchFeedbackList(search, newPage);
                    }}
                    totalPages={totalPages}
                  />
                </div>
              )}
            </main>
          </main>
        </div>
      </div>

      <CreateFeedbackModal
        isOpen={isOpen}
        onClose={closeModal}
        onSuccess={() => fetchFeedbackList(search, page)}
        managerList={managerList}
        participantsList={participantsList}
        loadingManagers={loadingManagers}
        loadingParticipants={loadingParticipants}
        selectedParticipantForm={selectedParticipantForm}
        setSelectedParticipantForm={setSelectedParticipantForm}
      />

      <FeedbackDetailModal
        isOpen={detailModalOpen}
        onClose={closeDetailModal}
        feedback={selectedFeedback}
        onFeedbackUpdate={(uuid, newAssessment) => {
          setFeedbackList(prevList =>
            prevList.map(item =>
              item.uuid === uuid
                ? { ...item, feedback_assessment: newAssessment }
                : item
            )
          );
          if (selectedFeedback?.uuid === uuid) {
            setSelectedFeedback(prev => ({ ...prev, feedback_assessment: newAssessment }));
          }
        }}
      />
    </>
  );
};

export default EmployeeFeedback;
